module.exports = __webpack_public_path__ + "937ddf6605a1d0445fa5e4f936f059e8.pdf";